/* eslint-disable max-len */
const ceTree = [
  {
    tag: 'EAR',
    // type: 'Please choose the affected ear',
    type: 'Ear',
    answer: 'START',
    question: 'affectedEar',
    buttons: [
      {
        label: 'LEFT',
        nextTag: 'ROOT',
      },
      {
        label: 'RIGHT',
        nextTag: 'ROOT',
      },
    ],
    links: [],
    head: 'Please choose the affected ear',
    body:
      '<span class="font-weight-bold">Please note</span><br />The contralateral ear (in aided condition) should always be considered during the candidacy selection process. This tool however only focuses on one ear at the time. In case of an asymmetric hearing loss, it is important to assess the reason for it before deciding for a treatment option.',
    component: 'DoubleChoice',
  },
  {
    tag: 'ROOT',
    parent: 'EAR',
    type: 'Audiological',
    question: 'hearingLossType',
    answer: 'LEFT or RIGHT',
    buttons: [
      {
        label: 'CHL',
        nextTag: 'CHL1-1',
        title: 'Conductive',
        description: 'Any problem in the outer or middle ear that prevents sound from being conducted properly is known as a conductive hearing loss (CHL). Conductive hearing losses are usually mild or moderate in degree, ranging from 25 to 65 decibels.',
      },
      {
        label: 'MHL',
        nextTag: 'MHL1-1',
        title: 'Mixed',
        description: 'A mixed hearing loss (MHL) is a combination of a sensorineural and conductive hearing loss. It results from problems in both the inner and outer or middle ear.',
      },
      {
        label: 'SNHL',
        nextTag: 'SN-ROOT',
        title: 'Sensorineural',
        description: 'Sensorineural hearing loss (SNHL) results from missing or damaged sensory cells (hair cells) in the cochlea and  usually permanent. Also known as “nerve deafness”, sensorineural hearing loss can be mild, moderate, severe or profound.',
      },
      {
        label: 'SSD',
        nextTag: 'SSL1-1',
        title: 'Single-Sided Deafness',
        description: 'Single-Sided Deafness (SSD) is a hearing loss that occurs in only one ear, while the other ear has normal hearing or only mild hearing loss. SSD makes it hard to understand speech and sounds especially in noisy environments, as well as causing difficulties in determining the direction of a sound\'s location.',
      },
      {
        label: 'NHL',
        nextTag: 'NHL1-1',
        title: 'Neural',
        description: 'A problem that results from the absence of or damage to the auditory nerve can cause a neural hearing loss (RHL). Neural hearing loss is usually profound and permanent. Hearing aids and cochlear implants cannot help because the nerve is not able to pass on sound information to the brain.',
      },
    ],
    links: [],
    head: 'Select the hearing loss',
    body: '',
    component: 'Selector',
  },
  {
    tag: 'SSL1-1',
    parent: 'ROOT',
    type: 'Audiological',
    reference: 'IFU BONEBRIDGE for SSD',
    answer: 'SSD',
    buttons: [
      {
        label: 'YES',
        nextTag: 'SSL2-1Y',
      },
      {
        label: 'NO',
        nextTag: 'SSL2-2N',
      },
    ],
    links: [],
    body: 'Is the AFFECTED ear in the severe-to-profound sensorineural hearing loss range?',
    component: 'DoubleChoice',
  },
  {
    tag: 'SSL2-1Y',
    parent: 'SSL1-1',
    type: 'Medical',
    reference: 'IFU BONEBRIDGE for SSD',
    answer: 'YES',
    buttons: [
      {
        label: 'YES',
        nextTag: 'SSL3-1Y',
      },
      {
        label: 'NO',
        nextTag: 'SSL3-2N',
      },
    ],
    links: [],
    body: 'Is the CONTRALATERAL ear in normal or mild hearing loss range, with an absence of retrocochlear and central auditory disorders?',
    component: 'DoubleChoice',
  },
  {
    tag: 'SSL2-2N',
    parent: 'SSL1-1',
    type: 'Conclusion',
    answer: 'NO',
    buttons: [],
    links: [],
    body: 'Based on the information provided, the candidate is not within the criteria of singe-sided deafness. Please select another hearing loss type by pressing the Home button below or contact your nearest MED-EL representative for further assistance on this case.',
    component: 'Conclusion',
  },
  {
    tag: 'SSL3-1Y',
    parent: 'SSL2-1Y',
    type: 'Medical',
    reference: 'IFU BONEBRIDGE for SSD',
    answer: 'YES',
    buttons: [
      {
        label: 'YES',
        nextTag: 'SSL4-1Y',
      },
      {
        label: 'NO',
        nextTag: 'SSL4-2N',
      },
    ],
    links: [],
    body: 'Is there a cochlear nerve deficiency in the AFFECTED ear?',
    component: 'DoubleChoice',
  },
  {
    tag: 'SSL3-2N',
    parent: 'SSL2-1Y',
    type: 'Medical',
    answer: 'NO',
    buttons: [
      {
        label: 'YES',
        nextTag: 'SSL4-3Y',
      },
      {
        label: 'NO',
        nextTag: 'SSL4-4N',
      },
    ],
    links: [],
    body: 'Is the CONTRALATERAL ear in the mild-to-moderate hearing loss range, with an absence of retrocochlear and central auditory disorders?',
    component: 'DoubleChoice',
  },
  {
    tag: 'SSL4-3Y',
    page: 'SSD=CI',
    parent: 'SSL3-2N',
    type: 'Conclusion',
    answer: 'YES',
    buttons: [],
    links: [
      {
        label: 'CI',
        solution: 'Cochlear Implant System',
        href: 'https://www.medel.com/hearing-solutions/cochlear-implants',
        description: '• Ideal for individuals with a severe to profound sensorineural hearing loss in the affected ear and normal or mild to moderate hearing loss in the contralateral ear <br />• Offers binaural hearing <br />• Electrical stimulation of the entire cochlea<br />• Most gentle electrode preserving the delicate structures of the inner ear<br />• Most physiological stimulation of the inner ear offering a sound impression as close as possible to the contralateral ear',
        image: 'ci',
      },
    ],
    head: 'Please keep in mind that counselling is crucial for candidates with single-sided deafness.<br /><br />The information you provided indicates possible candidacy for:',
    component: 'Conclusion',
  },
  {
    tag: 'SSL4-4N',
    parent: 'SSL3-2N',
    type: 'Conclusion',
    answer: 'NO',
    buttons: [],
    links: [],
    body: 'Based on the information provided, the candidate is not within the criteria of singe-sided deafness. Please select another hearing loss type by pressing the Home button below or contact your nearest MED-EL representative for further assistance on this case.',
    component: 'Conclusion',
  },
  {
    tag: 'SSL4-1Y',
    page: 'SSD=A+BB',
    parent: 'SSL3-1Y',
    type: 'Conclusion',
    answer: 'YES',
    buttons: [],
    links: [
      {
        label: 'ADHEAR',
        solution: 'Bone Conduction System',
        href: 'https://www.medel.com/hearing-solutions/bone-conduction-system',
        description: '• Ideal for individuals with a severe to profound sensorineural hearing loss in the affected ear and normal hearing in the contralateral ear <br />• Free external auditory canal <br />• Non-implantable solution without age restriction <br />• No pressure on the skin<br />• Cosmetically appealing',
        image: 'adhear',
      },

      {
        label: 'BONEBRIDGE',
        solution: 'Bone Conduction Implant System',
        href: 'https://www.medel.com/hearing-solutions/bonebridge',
        description: '• Ideal for individuals with a severe to profound sensorineural hearing loss in the affected ear and normal hearing in the contralateral ear <br />• Direct bone conduction stimulation offers wide frequency range <br />• Free external auditory canal <br />• Comfortable and discreet audio processor<br />• Intact skin solution<br />• Suitable for candidates aged 5 years or older',
        image: 'bonebridge',
      },
    ],
    head: 'Please keep in mind that counselling is crucial for candidates with single-sided deafness.<br /><br />The information you provided indicates possible candidacy for:',
    component: 'Conclusion',
  },
  {
    tag: 'SSL4-2N',
    page: 'SSD=CI+BB+A',
    parent: 'SSL3-1Y',
    type: 'Conclusion',
    answer: 'NO',
    buttons: [],
    links: [
      {
        label: 'CI',
        solution: 'Cochlear Implant System',
        href: 'https://www.medel.com/hearing-solutions/cochlear-implants',
        description: '• Ideal for individuals with a severe to profound sensorineural hearing loss in the affected ear and normal or mild to moderate hearing loss in the contralateral ear <br />• Offers binaural hearing <br />• Electrical stimulation of the entire cochlea<br />• Most gentle electrode preserving the delicate structures of the inner ear<br />• Most natural stimulation of the inner ear offering a sound impression as close as possible to normal hearing on the contralateral ear',
        image: 'ci',
      },
      {
        label: 'ADHEAR',
        solution: 'Bone Conduction System',
        href: 'https://www.medel.com/hearing-solutions/bone-conduction-system',
        description: '• Ideal for individuals with a severe to profound sensorineural hearing loss in the affected ear and normal hearing in the contralateral ear <br />• Free external auditory canal <br />• Non-implantable solution without age restriction <br />• No pressure on the skin<br />• Cosmetically appealing',
        image: 'adhear',
      },
      {
        label: 'BONEBRIDGE',
        solution: 'Bone Conduction Implant System',
        href: 'https://www.medel.com/hearing-solutions/bonebridge',
        description: '• Ideal for individuals with a severe to profound sensorineural hearing loss in the affected ear and normal hearing in the contralateral ear <br />• Direct bone conduction stimulation offers wide frequency range <br />• Free external auditory canal <br />• Comfortable and discreet audio processor<br />• Intact skin solution<br />• Suitable for candidates aged 5 years or older',
        image: 'bonebridge',
      },
    ],
    head: 'Please keep in mind that counselling is crucial for candidates with single-sided deafness.<br /><br />The information you provided indicates possible candidacy for:',
    component: 'Conclusion',
  },
  {
    tag: 'MHL1-1',
    parent: 'ROOT',
    type: 'Audiological',
    reference: 'VSB - IFU - VORP 503 Implant Kit, page 5 (Contraindications)',
    answer: 'MHL',
    buttons: [
      {
        label: 'YES',
        nextTag: 'MHL2-1Y',
      },
      {
        label: 'NO',
        nextTag: 'MHL2-2N',
      },
    ],
    addInfo: 'No more than 15 dB fluctuation (increase or decrease over the past 2 years)',
    links: [],
    body: 'Are the bone conduction values stable*?',
    component: 'DoubleChoice',
  },
  {
    tag: 'MHL2-1Y',
    parent: 'MHL1-1',
    type: 'Audiological',
    image: 'BB_IND_01',
    reference: 'Candidacy Guidelines page 12',
    answer: 'YES',
    buttons: [
      {
        label: 'YES',
        nextTag: 'MHL3-1Y',
      },
      {
        label: 'NO',
        nextTag: 'MHL3-2N',
      },
    ],
    links: [],
    body: 'Are the bone conduction values better than or equal to 45 dBHL at 500 - 4000 Hz?',
    component: 'DoubleChoice',
  },
  {
    tag: 'MHL2-2N',
    parent: 'MHL1-1',
    type: 'Audiological',
    reference: 'VSB - IFU - VORP 503 Implant Kit, page 5 (Contraindications)',
    answer: 'NO',
    buttons: [
      {
        label: 'Continue',
        nextTag: 'MHL2-1Y',
      },
    ],
    links: [],
    body: 'If the hearing loss is fluctuating more than 15 dB (increasing or decreasing over the past 2 years), most implant solutions are contraindicated. Therefore, conventional hearing aids might be a solution until the hearing loss stabilizes. Further medical investigation might be considered.',
    component: 'SingleChoice',
  },
  {
    tag: 'MHL3-1Y',
    parent: 'MHL2-1Y',
    type: 'Audiological',
    reference: 'Candidacy Guidelines page 12',
    answer: 'YES',
    buttons: [
      {
        label: 'YES',
        nextTag: 'MHL4-1Y',
      },
      {
        label: 'NO',
        nextTag: 'MHL4-2N',
      },
    ],
    addInfo: 'Difference between air and bone conduction values',
    links: [],
    body: 'Is the air-bone gap* larger than or equal to 30dB at 500 - 4000 Hz?',
    component: 'DoubleChoice',
  },
  {
    tag: 'MHL3-2N',
    parent: 'MHL2-1Y',
    type: 'Audiological',
    image: 'VSB_CHL_IND_01',
    reference: 'Candidacy Guidelines page 12',
    answer: 'NO',
    buttons: [
      {
        label: 'YES',
        nextTag: 'MHL4-3Y',
      },
      {
        label: 'NO',
        nextTag: 'MHL4-4N',
      },
    ],
    links: [],
    body: 'Are the bone conduction values within this extended shaded area?',
    component: 'DoubleChoice',
  },
  {
    tag: 'MHL4-1Y',
    parent: 'MHL3-1Y',
    type: 'Medical',
    reference: 'Candidacy Guidelines page 12',
    answer: 'YES',
    buttons: [
      {
        label: 'YES',
        nextTag: 'MHL5-1Y',
      },
      {
        label: 'NO',
        nextTag: 'MHL5-2N',
      },
    ],
    links: [],
    body: 'Are there any active middle ear infections?',
    component: 'DoubleChoice',
  },
  {
    tag: 'MHL4-2N',
    parent: 'MHL3-1Y',
    type: 'Medical',
    reference: 'Candidacy Guidelines page 12',
    answer: 'NO',
    buttons: [
      {
        label: 'YES',
        nextTag: 'MHL5-3Y',
      },
      {
        label: 'NO',
        nextTag: 'MHL5-4N',
      },
    ],
    links: [],
    body: 'Are there any active middle ear infections?',
    component: 'DoubleChoice',
  },
  {
    tag: 'MHL4-3Y',
    parent: 'MHL3-2N',
    type: 'Medical',
    reference: 'Candidacy Guidelines page 12',
    answer: 'YES',
    buttons: [
      {
        label: 'YES',
        nextTag: 'MHL5-5Y',
      },
      {
        label: 'NO',
        nextTag: 'MHL5-6N',
      },
    ],
    links: [],
    body: 'Are there any active middle ear infections?',
    component: 'DoubleChoice',
  },
  {
    tag: 'MHL4-4N',
    parent: 'MHL3-2N',
    type: 'Medical',
    answer: 'NO',
    buttons: [],
    links: [],
    body: 'If the bone conduction values of the mixed hearing loss do not fall within the criteria shown in the graph, MED-EL’s middle ear implants and bone conduction implants will not be effective. To assess a potential Hearing Aid or Cochlear Implant candidate, please contact your nearest MED-EL representative.',
    component: 'Conclusion',
  },
  {
    tag: 'MHL5-1Y',
    parent: 'MHL4-1Y',
    type: 'Medical',
    answer: 'YES',
    buttons: [
      {
        label: 'YES',
        nextTag: 'MHL6-1Y',
      },
      {
        label: 'NO',
        nextTag: 'MHL6-2N',
      },
    ],
    links: [],
    body: 'Can a retrocochlear and central auditory disorder be excluded?',
    component: 'DoubleChoice',
  },
  {
    tag: 'MHL5-2N',
    parent: 'MHL4-1Y',
    type: 'Medical',
    answer: 'NO',
    buttons: [
      {
        label: 'YES',
        nextTag: 'MHL6-3Y',
      },
      {
        label: 'NO',
        nextTag: 'MHL6-4N',
      },
    ],
    links: [],
    body: 'Can a retrocochlear and central auditory disorder be excluded?',
    component: 'DoubleChoice',
  },
  {
    tag: 'MHL5-3Y',
    parent: 'MHL4-2N',
    type: 'Medical',
    reference: 'Candidacy Guidelines, page 11',
    answer: 'YES',
    buttons: [{
      label: 'Continue',
      nextTag: 'MHL5-4N',
    }],
    links: [],
    body: 'In mixed hearing loss cases with an active middle ear infection, treatment and eradication of the pathology is required before implantation can be considered.',
    component: 'SingleChoice',
  },
  {
    tag: 'MHL5-4N',
    parent: 'MHL4-2N',
    type: 'Medical',
    answer: 'NO',
    buttons: [
      {
        label: 'YES',
        nextTag: 'MHL6-5Y',
      },
      {
        label: 'NO',
        nextTag: 'MHL6-6N',
      },
    ],
    links: [],
    body: 'Can a retrocochlear and central auditory disorder be excluded?',
    component: 'DoubleChoice',
  },
  {
    tag: 'MHL5-5Y',
    parent: 'MHL4-3Y',
    type: 'Medical',
    answer: 'YES',
    buttons: [
      {
        label: 'YES',
        nextTag: 'MHL6-7Y',
      },
      {
        label: 'NO',
        nextTag: 'MHL6-8N',
      },
    ],
    links: [],
    body: 'Can a retrocochlear and central auditory disorder be excluded?',
    component: 'DoubleChoice',
  },
  {
    tag: 'MHL5-6N',
    parent: 'MHL4-3Y',
    type: 'Medical',
    answer: 'NO',
    buttons: [
      {
        label: 'YES',
        nextTag: 'MHL6-9Y',
      },
      {
        label: 'NO',
        nextTag: 'MHL6-10N',
      },
    ],
    links: [],
    body: 'Can a retrocochlear and central auditory disorder be excluded?',
    component: 'DoubleChoice',
  },
  {
    tag: 'MHL6-1Y',
    page: 'MHL=VSB+BB',
    parent: 'MHL5-1Y',
    type: 'Conclusion',
    answer: 'YES',
    buttons: [],
    links: [
      {
        label: 'VIBRANT SOUNDBRIDGE',
        solution: 'Middle Ear Implant System',
        href: 'https://www.medel.com/hearing-solutions/vibrant-soundbridge',
        description: '• Ideal for patients with mild and moderate inner ear hearing loss and persistent air-bone gap<br />• Direct stimulation of the inner ear offers natural hearing<br />• Free external auditory canal <br />• Comfortable and discreet audio processor <br />• Intact skin solution<br />• Suitable for candidates aged 5 years or older',
        image: 'vsb',
      },
      {
        label: 'BONEBRIDGE',
        solution: 'Bone Conduction Implant System',
        href: 'https://www.medel.com/hearing-solutions/bonebridge',
        description: '• Ideal for patients with mild inner ear hearing loss and a persistent air-bone gap larger than or equal to 30dB <br />• Direct bone conduction stimulation offers natural hearing <br />• Free external auditory canal <br />• Comfortable and discreet audio processor <br />• Intact skin solution<br />• Suitable for candidates aged 5 years or older',
        image: 'bonebridge',
      },
    ],
    head: 'From an audiological point of view, both the VIBRANT SOUNDBRIDGE and BONEBRIDGE could be possible solutions. However, it is essential to eradicate the middle ear infection before considering a middle ear implant or the retrosigmoidal placement of a bone conduction implant should be considered. In case of a bone conduction implant, please make sure to evaluate its possible influence on the contralateral inner ear.<br /><br />The information you provided indicates possible candidacy for:',
    component: 'Conclusion',
  },
  {
    tag: 'MHL6-2N',
    parent: 'MHL5-1Y',
    type: 'Conclusion',
    reference: 'Candidacy Guidelines Implantable Hearing Loss Solutions',
    answer: 'NO',
    buttons: [],
    links: [],
    body: 'If the auditory nerve and/or the upper auditory pathway are NOT functioning, this is a contraindication for a cochlear, middle ear or bone conduction implant in the affected ear. For further information please contact your nearest MED-EL representative.',
    component: 'Conclusion',
  },
  {
    tag: 'MHL6-3Y',
    page: 'MHL=VSB+BB',
    parent: 'MHL5-2N',
    type: 'Conclusion',
    answer: 'YES',
    buttons: [],
    links: [
      {
        label: 'VIBRANT SOUNDBRIDGE',
        solution: 'Middle Ear Implant System',
        href: 'https://www.medel.com/hearing-solutions/vibrant-soundbridge',
        description: 'Middle Ear Implant System<br />• Ideal for patients with mild and moderate inner ear hearing loss and persistent air-bone gap<br />• Direct stimulation of the inner ear offers natural hearing<br />• Free external auditory canal <br />• Comfortable and discreet audio processor <br />• Intact skin solution<br />• Suitable for candidates aged 5 years or older',
        image: 'vsb',
      },
      {
        label: 'BONEBRIDGE',
        solution: 'Bone Conduction Implant System',
        href: 'https://www.medel.com/hearing-solutions/bonebridge',
        description: '• Ideal for patients with mild inner ear hearing loss and a persistent air-bone gap larger than or equal to 30dB <br />• Direct bone conduction stimulation offers natural hearing <br />• Free external auditory canal <br />• Comfortable and discreet audio processor <br />• Intact skin solution<br />• Suitable for candidates aged 5 years or older',
        image: 'bonebridge',
      },
    ],
    head: 'In case of a bone conduction implant, please make sure to evaluate its possible influence on the contralateral inner ear. The information you provided indicates possible candidacy for:',
    component: 'Conclusion',
  },
  {
    tag: 'MHL6-4N',
    parent: 'MHL5-2N',
    type: 'Conclusion',
    reference: 'Candidacy Guidelines Implantable Hearing Loss Solutions',
    answer: 'NO',
    buttons: [],
    links: [],
    body: 'If the auditory nerve and/or the upper auditory pathway are NOT functioning, this is a contraindication for a cochlear, middle ear or bone conduction implant in the affected ear. For further information please contact your nearest MED-EL representative.',
    component: 'Conclusion',
  },
  {
    tag: 'MHL6-5Y',
    page: 'MHL=VSB',
    parent: 'MHL5-4N',
    type: 'Conclusion',
    answer: 'YES',
    buttons: [],
    links: [
      {
        label: 'VIBRANT SOUNDBRIDGE',
        solution: 'Middle Ear Implant System',
        href: 'https://www.medel.com/hearing-solutions/vibrant-soundbridge',
        description: '• Ideal for patients with mild and moderate inner ear hearing loss and persistent air-bone gap<br />• Direct stimulation of the inner ear offers natural hearing<br />• Free external auditory canal <br />• Comfortable and discreet audio processor <br />• Intact skin solution<br />• Suitable for candidates aged 5 years or older',
        image: 'vsb',
      },
    ],
    body: 'The information you provided indicates possible candidacy for:',
    component: 'Conclusion',
  },
  {
    tag: 'MHL6-6N',
    parent: 'MHL5-4N',
    type: 'Conclusion',
    reference: 'Candidacy Guidelines Implantable Hearing Loss Solutions',
    answer: 'NO',
    buttons: [],
    links: [],
    body: 'If the auditory nerve and/or the upper auditory pathway are NOT functioning, this is a contraindication for a cochlear, middle ear or bone conduction implant in the affected ear. For further information please contact your nearest MED-EL representative.',
    component: 'Conclusion',
  },
  {
    tag: 'MHL6-7Y',
    page: 'MHL=VSB',
    parent: 'MHL5-5Y',
    type: 'Conclusion',
    answer: 'YES',
    buttons: [],
    links: [
      {
        label: 'VIBRANT SOUNDBRIDGE',
        solution: 'Middle Ear Implant System',
        href: 'https://www.medel.com/hearing-solutions/vibrant-soundbridge',
        description: '• Ideal for patients with mild and moderate inner ear hearing loss and persistent air-bone gap<br />• Direct stimulation of the inner ear offers natural hearing<br />• Free external auditory canal <br />• Comfortable and discreet audio processor <br />• Intact skin solution<br />• Suitable for candidates aged 5 years or older',
        image: 'vsb',
      },
    ],
    head: 'From an audiological point of view, a VIBRANT SOUNDBRIDGE could be a possible solution. However, it is essential to eradicate the middle ear infection before considering a middle ear implant.<br /><br />The information you provided indicates possible candidacy for:',
    component: 'Conclusion',
  },
  {
    tag: 'MHL6-8N',
    parent: 'MHL5-5Y',
    type: 'Conclusion',
    reference: 'Candidacy Guidelines Implantable Hearing Loss Solutions',
    answer: 'NO',
    buttons: [],
    links: [],
    body: 'If the auditory nerve and/or the upper auditory pathway are NOT functioning, this is a contraindication for a cochlear, middle ear or bone conduction implant in the affected ear. For further information please contact your nearest MED-EL representative.',
    component: 'Conclusion',
  },
  {
    tag: 'MHL6-9Y',
    page: 'MHL=VSB',
    parent: 'MHL5-6N',
    type: 'Conclusion',
    answer: 'YES',
    buttons: [],
    links: [
      {
        label: 'VIBRANT SOUNDBRIDGE',
        solution: 'Middle Ear Implant System',
        href: 'https://www.medel.com/hearing-solutions/vibrant-soundbridge',
        description: '• Ideal for patients with mild and moderate inner ear hearing loss and persistent air-bone gap<br />• Direct stimulation of the inner ear offers natural hearing<br />• Free external auditory canal <br />• Comfortable and discreet audio processor <br />• Intact skin solution<br />• Suitable for candidates aged 5 years or older',
        image: 'vsb',
      },
    ],
    body: 'The information you provided indicates possible candidacy for:',
    component: 'Conclusion',
  },
  {
    tag: 'MHL6-10N',
    parent: 'MHL5-6N',
    type: 'Conclusion',
    reference: 'Candidacy Guidelines Implantable Hearing Loss Solutions',
    answer: 'NO',
    buttons: [],
    links: [],
    body: 'If the auditory nerve and/or the upper auditory pathway are NOT functioning, this is a contraindication for a cochlear, middle ear or bone conduction implant in the affected ear. For further information please contact your nearest MED-EL representative.',
    component: 'Conclusion',
  },
  {
    tag: 'CHL1-1',
    parent: 'ROOT',
    type: 'Audiological',
    reference: 'Candidacy guidelines Implantable hearing Loss Solutions, page 10 ',
    answer: 'CHL',
    buttons: [
      {
        label: 'YES',
        nextTag: 'CHL2-1Y',
      },
      {
        label: 'NO',
        nextTag: 'CHL3-1Y',
      },
    ],
    addInfo: 'The hearing loss is expected to improve with conventional medical treatment',
    links: [],
    body: 'Is the hearing loss temporary*?',
    component: 'DoubleChoice',
  },
  {
    tag: 'CHL2-1Y',
    page: 'CHL=A',
    parent: 'CHL1-1',
    type: 'Conclusion',
    answer: 'YES',
    buttons: [],
    links: [
      {
        label: 'ADHEAR',
        solution: 'Bone Conduction System',
        href: 'https://www.medel.com/hearing-solutions/bone-conduction-system',
        description: '• Ideal for children and adults with malformations of the ear <br />• Ideal for children and adults with temporary and persistent middle ear issues<br />• Non-implantable solution without age restriction <br />• No pressure on the skin<br />• Cosmetically appealing',
        image: 'adhear',
      },
    ],
    body: 'The information you provided indicates possible candidacy for:',
    component: 'Conclusion',
  },
  {
    tag: 'CHL3-1Y',
    parent: 'CHL1-1',
    type: 'Audiological',
    reference: 'VSB - IFU - VORP 503 Implant Kit, page 5 (Contraindications)',
    answer: 'NO',
    buttons: [
      {
        label: 'YES',
        nextTag: 'CHL4-1Y',
      },
      {
        label: 'NO',
        nextTag: 'CHL5-4N',
      },
    ],
    addInfo: 'Difference between air and bone conduction values',
    links: [],
    body: 'Is the air-bone gap* larger than or equal to 30dB at 500 - 4000 Hz?',
    component: 'DoubleChoice',
  },
  {
    tag: 'CHL4-1Y',
    parent: 'CHL3-1Y',
    type: 'Medical',
    reference: 'Candidacy Guidelines – Implantable Hearing Loss Solutions page 11',
    answer: 'YES',
    buttons: [
      {
        label: 'YES',
        nextTag: 'CHL5-1Y',
      },
      {
        label: 'NO',
        nextTag: 'CHL5-2N',
      },
    ],
    links: [],
    body: 'Are there any chronic middle ear infections?',
    component: 'DoubleChoice',
  },
  {
    tag: 'CHL5-1Y',
    page: 'CHL=A+BB',
    parent: 'CHL4-1Y',
    type: 'Conclusion',
    answer: 'YES',
    buttons: [],
    links: [
      {
        label: 'ADHEAR',
        solution: 'Bone Conduction System',
        href: 'https://www.medel.com/hearing-solutions/bone-conduction-system',
        description: '• Ideal for children and adults with malformations of the ear <br />• Ideal for children and adults with temporary and persistent middle ear issues<br />• Non-implantable solution without age restriction <br />• No pressure on the skin<br />• Cosmetically appealing',
        image: 'adhear',
      },
      {
        label: 'BONEBRIDGE',
        solution: 'Bone Conduction Implant System',
        href: 'https://www.medel.com/hearing-solutions/bonebridge',
        description: '• Ideal for children and adults with malformations of the ear<br />• Ideal for children and adults with persistent middle ear issues<br />• Direct bone conduction stimulation offers natural hearing  <br />• Comfortable and discreet audio processor <br />• Intact skin solution<br />• Suitable for candidates aged 5 years or older',
        image: 'bonebridge',
      },
    ],
    head: 'For candidates with a conductive hearing loss and a chronic middle ear infection, the first treatment option is often ear reconstruction or middle ear surgery. From an audiological point of view, both the ADHEAR and BONEBRIDGE could be possible solutions. However, in case of a BONEBRIDGE, due to the infection, retrosigmoidal placement should be considered.<br /><br />The information you provided indicates possible candidacy for:',
    component: 'Conclusion',
  },
  {
    tag: 'CHL5-2N',
    page: 'CHL=A+BB',
    parent: 'CHL4-1Y',
    type: 'Conclusion',
    answer: 'NO',
    buttons: [],
    links: [
      {
        label: 'ADHEAR',
        solution: 'Bone Conduction System',
        href: 'https://www.medel.com/hearing-solutions/bone-conduction-system',
        description: '• Ideal for children and adults with malformations of the ear <br />• Ideal for children and adults with temporary and persistent middle ear issues<br />• Non-implantable solution without age restriction <br />• No pressure on the skin<br />• Cosmetically appealing',
        image: 'adhear',
      },
      {
        label: 'BONEBRIDGE',
        solution: 'Bone Conduction Implant System',
        href: 'https://www.medel.com/hearing-solutions/bonebridge',
        description: '• Ideal for children and adults with malformations of the ear<br />• Ideal for children and adults with persistent middle ear issues<br />• Direct bone conduction stimulation offers natural hearing  <br />• Comfortable and discreet audio processor <br />• Intact skin solution<br />• Suitable for candidates aged 5 years or older',
        image: 'bonebridge',
      },
    ],
    body: 'The information you provided indicates possible candidacy for:',
    component: 'Conclusion',
  },
  {
    tag: 'CHL5-4N',
    page: 'CHL=A',
    parent: 'CHL3-1Y',
    type: 'Conclusion',
    answer: 'NO',
    buttons: [],
    links: [
      {
        label: 'ADHEAR',
        solution: 'Bone Conduction System',
        href: 'https://www.medel.com/hearing-solutions/bone-conduction-system',
        description: '• Ideal for children and adults with malformations of the ear <br />• Ideal for children and adults with temporary and persistent middle ear issues<br />• Non-implantable solution without age restriction <br />• No pressure on the skin<br />• Cosmetically appealing',
        image: 'adhear',
      },
    ],
    body: 'The information you provided indicates possible candidacy for:',
    component: 'Conclusion',
  },
  {
    tag: 'SN-ROOT',
    parent: 'ROOT',
    type: 'Audiological',
    image: 'VSB_SNHL_IND_01.png, CI_SNHL_IND_01.png, EAS_SNHL_IND_01.jpg',
    answer: 'SNHL',
    buttons: [
      {
        label: '1',
        nextTag: 'S1L1-1',
        image: 'VSB_SNHL_IND_01.png',
      },
      {
        label: '2',
        nextTag: 'S2L1-1',
        image: 'CI_SNHL_IND_01.png',
      },
      {
        label: '3',
        nextTag: 'S3L1-1',
        image: 'EAS_SNHL_IND_01.jpg',
      },
    ],
    links: [],
    head: 'Which shaded area contains the air conduction values?',
    body: null,
    component: 'Selector',
  },
  {
    tag: 'S1L1-1',
    parent: 'SN-ROOT',
    type: 'Audiological',
    reference: 'VSB - IFU - VORP 503 Implant Kit, page 5 (Indications)',
    answer: 'SNHL (VSB)',
    buttons: [
      {
        label: 'YES',
        nextTag: 'S1L2-1Y',
      },
      {
        label: 'NO',
        nextTag: 'S1L2-2N',
      },
    ],
    links: [],
    body: 'Is there any medical reason to prevent the use of conventional hearing aids?',
    component: 'DoubleChoice',
  },
  {
    tag: 'S1L2-1Y',
    parent: 'S1L1-1',
    type: 'Audiological',
    reference: 'VSB - IFU - VORP 503 Implant Kit, page 5 (Contraindications)',
    answer: 'YES',
    buttons: [
      {
        label: 'YES',
        nextTag: 'S1L3-1Y',
      },
      {
        label: 'NO',
        nextTag: 'S1L3-2N',
      },
    ],
    addInfo: 'No more than 15 dB fluctuation (increase or decrease over the past 2 years)',
    links: [],
    body: 'Is the hearing loss stable*?',
    component: 'DoubleChoice',
  },
  {
    tag: 'S1L2-2N',
    parent: 'S1L1-1',
    type: 'Audiological',
    answer: 'NO',
    buttons: [],
    links: [],
    body: 'Hearing aids should be considered as first-line treatment. In cases of discomfort, aesthetical issues, feedback, distortion or other complications, a middle ear implant can be considered.',
    component: 'Conclusion',
  },
  {
    tag: 'S1L3-1Y',
    parent: 'S1L2-1Y',
    type: 'Audiological',
    answer: 'YES',
    buttons: [
      {
        label: 'Continue',
        nextTag: 'S1L4-1Y',
      },
    ],
    links: [],
    body: 'Speech reception threshold (SRT) measurements might be useful to confirm the audiological findings.',
    component: 'SingleChoice',
  },
  {
    tag: 'S1L3-2N',
    parent: 'S1L2-1Y',
    type: 'Conclusion',
    reference: 'VSB - IFU - VORP 503 Implant Kit, page 5 (Contraindications)',
    answer: 'NO',
    buttons: [],
    links: [],
    body: 'If the hearing loss is fluctuating more than 15 dB (increasing or decreasing over the past 2 years), most implant solutions are contraindicated. Therefore, conventional hearing aids might be a solution until the hearing loss stabilizes. Further medical investigation might be considered.',
    component: 'Conclusion',
  },
  {
    tag: 'S1L4-1Y',
    parent: 'S1L3-1Y',
    type: 'Medical',
    reference: '28084_20_Selection Criteria Card EN',
    answer: 'Continue',
    buttons: [
      {
        label: 'YES',
        nextTag: 'S1L5-1Y',
      },
      {
        label: 'NO',
        nextTag: 'S1L5-2N',
      },
    ],
    links: [],
    head: 'Are the following criteria met?',
    body: 'Unaided speech understanding is better than 50% on the open-set word test with headphones, at the most comfortable listening level,<br />AND<br />The candidate benefits from amplification, indicating that there are no retrocochlear and/or central auditory disorders.',
    component: 'DoubleChoice',
  },
  {
    tag: 'S1L5-1Y',
    page: 'SNHL=VSB',
    parent: 'S1L4-1Y',
    type: 'Conclusion',
    reference: '28084_20_Selection Criteria Card EN',
    answer: 'YES',
    buttons: [],
    links: [
      {
        label: 'VIBRANT SOUNDBRIDGE',
        solution: 'Middle Ear Implant System',
        href: 'https://www.medel.com/hearing-solutions/vibrant-soundbridge',
        description: '• Ideal for patients with moderate to severe sensorineural hearing loss<br />• Only solution available for patients who are not able to wear hearing aids<br />• Free external auditory canal <br />• Comfortable and discreet audio processor <br />• Intact skin solution<br />• Suitable for candidates aged 5 years or older',
        image: 'vsb',
      },
    ],
    body: 'The information you provided indicates possible candidacy for:',
    component: 'Conclusion',
  },
  {
    tag: 'S1L5-2N',
    parent: 'S1L4-1Y',
    type: 'Conclusion',
    answer: 'NO',
    buttons: [],
    links: [],
    body: 'If the requested criteria are not met, the individual does not fall into the candidacy range for the VIBRANT SOUNDBRIDGE in sensorineural hearing loss. Please select another type of hearing loss type by pressing the Home button below or contact your nearest MED-EL representative for further assistance on this case.',
    component: 'Conclusion',
  },
  {
    tag: 'S2L1-1',
    parent: 'SN-ROOT',
    type: 'Audiological',
    reference: 'Candidacy Guidelines Implantable Hearing Loss Solutions, page 5',
    answer: 'SNHL (CI)',
    buttons: [
      {
        label: 'YES',
        nextTag: 'S2L3-1Y',
      },
      {
        label: 'NO',
        nextTag: 'S2L2-2N',
      },
    ],
    links: [],
    body: 'Were optimally fitted hearing aids used?',
    component: 'DoubleChoice',
  },
  {
    tag: 'S2L2-2N',
    parent: 'S2L1-1',
    type: 'Audiological',
    reference: 'Masterfile for Instructions for Use for Mi1200 Cochlear ImplantsDoc. No.: AW101916Rev.: / 8.0Effective Date: / 13. Nov. 2015Page: / 4 of  19',
    answer: 'NO',
    buttons: [],
    links: [],
    body: 'MED-EL strongly recommends using optimally fit hearing aids for a minimum of three months before deciding on implantation. However, if a candidate was deafened by an infectious disease, which can lead to ossification, and if there are signs of cochlear ossification there may be no need to try a hearing aid. In these cases, implantation should usually not be delayed.',
    component: 'Conclusion',
  },
  {
    tag: 'S2L3-1Y',
    parent: 'S2L1-1',
    type: 'Medical',
    reference: 'Candidacy Guidelines Implantable Hearing Loss Solutions, page 5',
    answer: 'YES',
    buttons: [
      {
        label: 'YES',
        nextTag: 'S2L4-1Y',
      },
      {
        label: 'NO or LITTLE',
        nextTag: 'S2L4-2N',
      },
    ],
    addInfo: 'Current use of an acoustic hearing aid at least 4 hours (average) per day for at least 3 months prior to evaluation',
    links: [],
    body: 'Is there sufficient benefit from acoustic amplification?',
    component: 'DoubleChoice',
  },
  {
    tag: 'S2L4-1Y',
    parent: 'S2L3-1Y',
    type: 'Conclusion',
    answer: 'YES',
    buttons: [],
    links: [],
    body: 'Adequate benefit from acoustic amplification precludes the need for implantation at the given point in time. If the hearing worsens or if there is no age appropriate progress over time, further assessment might be required. For further questions please contact your nearest MED-EL representative.',
    component: 'Conclusion',
  },
  {
    tag: 'S2L4-2N',
    parent: 'S2L3-1Y',
    type: 'Medical',
    reference: 'Masterfile for Instructions for Use for Mi1200 Cochlear ImplantsDoc. No.: AW101916Rev.: / 8.0Effective Date: / 13. Nov. 2015Page: / 4 of  19',
    answer: 'NO or LITTLE',
    buttons: [
      {
        label: 'YES',
        nextTag: 'S2L5-1Y',
      },
      {
        label: 'NO',
        nextTag: 'NHL2-1Y',
      },
    ],
    links: [],
    body: 'Is the auditory nerve and the upper auditory pathway functioning?',
    component: 'DoubleChoice',
  },
  {
    tag: 'S2L5-1Y',
    parent: 'S2L4-2N',
    type: 'Medical',
    reference: 'Masterfile for Instructions for Use for Mi1200 Cochlear ImplantsDoc. No.: AW101916Rev.: / 8.0Effective Date: / 13. Nov. 2015Page: / 4 of  19',
    answer: 'YES',
    buttons: [
      {
        label: 'YES',
        nextTag: 'S2L6-1Y',
      },
      {
        label: 'NO',
        nextTag: 'S2L6-2N',
      },
    ],
    links: [],
    body: 'Is the cochlea fully developed?',
    component: 'DoubleChoice',
  },
  {
    tag: 'S2L6-1Y',
    page: 'SNHL=CI',
    parent: 'S2L5-1Y',
    type: 'Conclusion',
    answer: 'YES',
    buttons: [],
    links: [
      {
        label: 'CI',
        solution: 'Cochlear Implant System',
        href: 'https://www.medel.com/hearing-solutions/cochlear-implants',
        description: '• Ideal for candidates of all ages with a severe to profound sensorineural hearing loss <br />• Electrical stimulation of the entire cochlea<br />• Most gentle electrode preserving the delicate structures of the inner ear<br />• Most natural stimulation of the inner ear offering a sound impression as close as possible to natural hearing',
        image: 'ci',
      },
    ],
    body: 'The information you provided indicates possible candidacy for:',
    component: 'Conclusion',
  },
  {
    tag: 'S2L6-2N',
    parent: 'S2L5-1Y',
    type: 'Conclusion',
    reference: 'Masterfile for Instructions for Use for Mi1200 Cochlear ImplantsDoc. No.: AW101916Rev.: / 8.0Effective Date: / 13. Nov. 2015Page: / 4 of  19',
    answer: 'NO',
    buttons: [
      {
        label: 'Continue',
        nextTag: 'S2L7-1A',
      },
    ],
    links: [],
    body: 'MED-EL offers a wide range of implant solution for various anatomies. The use of an (appropriate) implant should be carefully considered prior to surgery in case of anatomic abnormalities of the cochlea.',
    component: 'SingleChoice',
  },
  {
    tag: 'S2L7-1A',
    page: 'SNHL=CI',
    parent: 'S2L6-2N',
    type: 'Conclusion',
    answer: 'Continue',
    buttons: [],
    links: [
      {
        label: 'CI',
        solution: 'Cochlear Implant System',
        href: 'https://www.medel.com/hearing-solutions/cochlear-implants',
        description: '• Ideal for candidates of all ages with a severe to profound sensorineural hearing loss <br />• Electrical stimulation of the entire cochlea<br />• Most gentle electrode preserving the delicate structures of the inner ear<br />• Most natural stimulation of the inner ear offering a sound impression as close as possible to natural hearing',
        image: 'ci',
      },
    ],
    body: 'The information you provided indicates possible candidacy for:',
    component: 'Conclusion',
  },
  {
    tag: 'S3L1-1',
    parent: 'SN-ROOT',
    type: 'Audiological',
    reference: 'VSB - IFU - VORP 503 Implant Kit, page 5 (Contraindications)',
    answer: 'SNHL (EAS)',
    buttons: [
      {
        label: 'YES',
        nextTag: 'S3L2-1Y',
      },
      {
        label: 'NO',
        nextTag: 'S3L2-2N',
      },
    ],
    addInfo: 'No more than 15 dB fluctuation (increase or decrease over the past 2 years)',
    links: [],
    body: 'Is the hearing loss stable*?',
    component: 'DoubleChoice',
  },
  {
    tag: 'S3L2-1Y',
    parent: 'S3L1-1',
    type: 'Audiological',
    reference: 'Candidacy Guidelines, Implantable Hearing Loss Solutions, page 7',
    answer: 'YES',
    buttons: [
      {
        label: 'YES',
        nextTag: 'S3L3-1Y',
      },
      {
        label: 'NO',
        nextTag: 'S3L3-2N',
      },
    ],
    links: [],
    body: 'Is the monosyllabic word score equal to or worse than 60% at 65 dBHL in the best aided condition?',
    component: 'DoubleChoice',
  },
  {
    tag: 'S3L2-2N',
    parent: 'S3L1-1',
    type: 'Conclusion',
    reference: 'Candidacy Guidelines Implantable Hearing Loss Solutions',
    answer: 'NO',
    buttons: [],
    links: [],
    body: 'If the hearing loss is fluctuating more than 15 dB (increasing or decreasing over the past 2 years), most implant solutions are contraindicated. Further medical investigation might be considered.',
    component: 'Conclusion',
  },
  {
    tag: 'S3L3-1Y',
    parent: 'S3L2-1Y',
    type: 'Medical',
    reference: 'Candidacy Guidelines, Implantable Hearing Loss Solutions, page 7',
    answer: 'YES',
    buttons: [
      {
        label: 'YES',
        nextTag: 'S3L4-1Y',
      },
      {
        label: 'NO',
        nextTag: 'S3L4-2N',
      },
    ],
    links: [],
    body: 'Is the cochlea free of malformations or obstructions?',
    component: 'DoubleChoice',
  },
  {
    tag: 'S3L3-2N',
    parent: 'S3L2-1Y',
    type: 'Conclusion',
    answer: 'NO',
    buttons: [],
    links: [],
    body: 'If speech perception is better than 60% at 65 dBHL, a hearing aid might be considered as the most appropriate solution at the given point in time.',
    component: 'Conclusion',
  },
  {
    tag: 'S3L4-1Y',
    parent: 'S3L3-1Y',
    type: 'Medical',
    answer: 'YES',
    buttons: [
      {
        label: 'YES',
        nextTag: 'S3L5-1Y',
      },
      {
        label: 'NO',
        nextTag: 'S3L5-2N',
      },
    ],
    addInfo: 'No pathology of the outer ear is preventing the placement and usage of a hearing aid',
    links: [],
    body: 'Can a conventional hearing aid be worn*?',
    component: 'DoubleChoice',
  },
  {
    tag: 'S3L4-2N',
    parent: 'S3L3-1Y',
    type: 'Medical',
    reference: 'IFU: Mi1200 SYNCHRONY / Cochlear Implant / page: 7',
    answer: 'NO',
    buttons: [],
    links: [],
    body: 'If anatomic abnormalities are present, this prevents appropriate placement of the stimulator housing in the bone of the skull or the chosen electrode array into the cochlea. The use of an implant should be carefully considered prior to surgery.',
    component: 'Conclusion',
  },
  {
    tag: 'S3L5-1Y',
    page: 'SNHL=EAS',
    parent: 'S3L4-1Y',
    type: 'Conclusion',
    answer: 'YES',
    buttons: [],
    links: [
      {
        label: 'EAS',
        solution: 'Electric Acoustic Stimulation System',
        href: 'https://www.medel.com/hearing-solutions/electric-acoustic-stimulation',
        description: '• Ideal for individuals with partial deafness<br />• Most gentle electrode with the potential of preserving the residual hearing <br />• Synchrony of acoustic and electrical stimulation of the inner ear integrated in a single audio processor',
        image: 'eas',
      },
    ],
    body: 'The information you provided indicates possible candidacy for:',
    component: 'Conclusion',
  },
  {
    tag: 'S3L5-2N',
    parent: 'S3L4-1Y',
    type: 'Medical',
    answer: 'NO',
    buttons: [
      {
        label: 'Continue',
        nextTag: 'S3L6-1A',
      },
    ],
    links: [],
    body: 'Acute pathologies of the external auditory canal should be resolved before implantation. Chronic pathologies of the external auditory canal may prevent placement and usage of a hearing aid.',
    component: 'SingleChoice',
  },
  {
    tag: 'S3L6-1A',
    page: 'SNHL=EAS',
    parent: 'S3L5-2N',
    type: 'Conclusion',
    answer: 'Continue',
    buttons: [],
    links: [
      {
        label: 'EAS',
        solution: 'Electric Acoustic Stimulation System',
        href: 'https://www.medel.com/hearing-solutions/electric-acoustic-stimulation',
        description: '• Ideal for individuals with partial deafness<br />• Most gentle electrode with the potential of preserving the residual hearing <br />• Synchrony of acoustic and electrical stimulation of the inner ear integrated in a single audio processor',
        image: 'eas',
      },
    ],
    body: 'The information you provided indicates possible candidacy for:',
    component: 'Conclusion',
  },
  {
    tag: 'NHL1-1',
    parent: 'ROOT',
    type: 'Medical',
    answer: 'NHL',
    buttons: [
      {
        label: 'YES',
        nextTag: 'NHL2-1Y',
      },
      {
        label: 'NO',
        nextTag: 'NHL2-2N',
      },
    ],
    links: [],
    body: 'Is the auditory nerve non-functional or anticipated to be rendered non-functional by surgical intervention?',
    component: 'DoubleChoice',
  },
  {
    tag: 'NHL2-1Y',
    page: 'ABI',
    parent: 'NHL1-1',
    type: 'Conclusion',
    answer: 'YES',
    buttons: [],
    links: [
      {
        label: 'ABI',
        solution: 'Auditory Brainstem Implant System',
        href: 'http://www.medel.com/indications/#NFII',
        description: '<ul><li>Only solution to provide auditory input for patients who cannot benefit from cochlear implant due to non-functioning auditory nerve.</li><li>Candidates 12 months or older who cannot benefit from cochlear implant due to non-functioning auditory nerve. The cause of non-functioning auditory nerve may be:</li><ul><li>Congenital due to</li><ul><li>auditory nerve aplasia or</li><li>auditory nerve hypoplasia or</li></ul><li>Accrued during the life span due to</li><ul><li>cochlear nerve disruption due to head trauma or</li><li>non-NF2 tumor or</li><li>severe cochlear ossification.</li></ul></ul><li>Candidates aged 15 years or older affected by NF2</li></ul>',
        image: 'abi',
      },
    ],
    body: 'The information you provided indicates possible candidacy for:',
    component: 'Conclusion',
  },
  {
    tag: 'NHL2-2N',
    parent: 'NHL1-1',
    type: 'Conclusion',
    answer: 'NO',
    buttons: [],
    links: [],
    body: 'Based on the information provided, the candidate is not within the criteria for auditory brainstem implant (ABI). Please select another hearing loss type by pressing the Home button below or contact your nearest MED-EL representative for further assistance on this case.',
    component: 'Conclusion',
  },
];

export default ceTree;
